import { OnboardingFieldNames } from './base-config'

export const COMPENSATION_HOURLY_ID = 'hourly'
export const COMPENSATION_SALARY_ID = 'salary'
export const COMPENSATION_PRODUCTIVITY_WRVU_ID = 'productivityWrvu'
export const COMPENSATION_NET_INCOME_ID = 'netIncome'
export const COMPENSATION_COLLECTIONS_PERCENTAGE_ID = 'collectionsPercentage'
export const COMPENSATION_EQUAL_SHARES_ID = 'equalShares'
export const COMPENSATION_ACADEMIC_HYBRID_ID = 'academicHybrid'
export const COMPENSATION_OTHER_ID = 'other'

export const compensationModelOptions = [
  { label: 'Hourly', id: COMPENSATION_HOURLY_ID },
  { label: 'Salary', id: COMPENSATION_SALARY_ID },
  { label: 'Productivity (wRVU)', id: COMPENSATION_PRODUCTIVITY_WRVU_ID },
  { label: 'Net Income', id: COMPENSATION_NET_INCOME_ID },
  { label: '% of Collections', id: COMPENSATION_COLLECTIONS_PERCENTAGE_ID },
  { label: 'Equal Shares', id: COMPENSATION_EQUAL_SHARES_ID },
  { label: 'Academic Hybrid', id: COMPENSATION_ACADEMIC_HYBRID_ID },
  { label: 'Other', id: COMPENSATION_OTHER_ID },
]

export const NEW_JOB_SALARY_YES_ID = 'yes'
export const newJobSalaryOptions = [
  { id: NEW_JOB_SALARY_YES_ID, label: `Yes, it's new` },
  {
    id: 'no',
    label: `No, I've been here awhile`,
  },
]

export const bonusesOptions = [
  {
    label: 'Productivity Bonus',
    id: OnboardingFieldNames.CompensationProductivityBonus,
  },
  {
    label: 'Quality Bonus',
    id: OnboardingFieldNames.CompensationQualityBonus,
  },
  {
    label: 'Other Bonus',
    id: OnboardingFieldNames.CompensationOtherBonus,
  },
]

export const otherIncomeOptions = [
  {
    label: 'Overtime Income',
    id: OnboardingFieldNames.CompensationOtherOvertimeIncome,
  },
  {
    label: 'Leadership Stipend',
    id: OnboardingFieldNames.CompensationOtherLeadershipStipend,
  },
  {
    label: 'Partner Income',
    id: OnboardingFieldNames.CompensationOtherPartnerIncome,
  },
  {
    label: 'Rank Adjustment',
    id: OnboardingFieldNames.CompensationOtherRankAdjustment,
  },
  {
    label: 'Non-Clinical Income',
    id: OnboardingFieldNames.CompensationOtherNonClinicalIncome,
  },
  {
    label: 'Ancillary Income',
    id: OnboardingFieldNames.CompensationOtherOtherAncillaryIncome,
  },
]

export const COMPENSATION_MORE_INCOME_SIGNING_BONUS_ID = 'signingBonus'
export const COMPENSATION_MORE_INCOME_RELOCATION_BONUS_ID = 'relocationBonus'
export const COMPENSATION_MORE_INCOME_LOAN_ASSISTANCE_ID = 'loanAssistance'
export const COMPENSATION_MORE_INCOME_RESIDENCY_STIPEND_ID = 'residencyStipend'

export const compensationMoreIncomeOptions = [
  {
    label: 'Signing Bonus',
    id: COMPENSATION_MORE_INCOME_SIGNING_BONUS_ID,
  },
  {
    label: 'Relocation Bonus',
    id: COMPENSATION_MORE_INCOME_RELOCATION_BONUS_ID,
  },
  { label: 'Loan Assistance', id: COMPENSATION_MORE_INCOME_LOAN_ASSISTANCE_ID },
  {
    label: 'Residency Stipend',
    id: COMPENSATION_MORE_INCOME_RESIDENCY_STIPEND_ID,
  },
]

export const salaryRules_0 = {
  min: { value: 0, message: 'Must be at least $0' },
  max: { value: 999999999, message: 'Cannot be more than $999,999,999' },
}

export const salaryRules_1 = {
  min: { value: 1, message: 'Must be at least $1' },
  max: { value: 999999999, message: 'Cannot be more than $999,999,999' },
}

export const salaryPerHourRules_0 = {
  min: { value: 0, message: 'Must be at least $0/hr' },
  max: { value: 999999999, message: 'Cannot be more than $999,999,999/hr' },
}

export const salaryPerHourRules_1 = {
  min: { value: 1, message: 'Must be at least $1/hr' },
  max: { value: 999999999, message: 'Cannot be more than $999,999,999/hr' },
}

export const salaryPerDayRules = {
  min: { value: 0, message: 'Must be at least $0/day' },
  max: { value: 999999999, message: 'Cannot be more than $999,999,999/day' },
}

export const targetWrvuRules = {
  min: { value: 1, message: 'Target wRVUs must be at least 1' },
  max: {
    value: 999999999,
    message: 'Target wRVUs cannot be more than 999,999,999',
  },
}

export const wrvuRateRules = {
  min: { value: 1, message: 'Must be at least $1/wRVU' },
  max: { value: 999999999, message: 'Cannot be more than $999,999,999/wRVU' },
}

export const percentageRules = {
  min: { value: 0, message: 'Must be at least 0%' },
  max: { value: 100, message: 'Cannot be more than 100%' },
}
